export default __webpack_public_path__ + "core-logo-dark.3138cae2.png";